import { jsx as t, jsxs as l } from "react/jsx-runtime";
import { useTranslation as I, Trans as v } from "react-i18next";
import z from "classnames";
import h from "../../../components/Button/index.js";
import b from "../../../icons/Upload.js";
import F from "../icons/file-accepted.js";
import g from "../icons/file-placeholder.js";
import j from "../icons/file-rejected.js";
const C = "forma-ui__file-dropzone-content__acceptIcon", P = "forma-ui__file-dropzone-content__acceptFormat", w = "forma-ui__file-dropzone-content__title", T = "forma-ui__file-dropzone-content__placeholder", y = "forma-ui__file-dropzone-content__content", x = "forma-ui__file-dropzone-content__button", B = "forma-ui__file-dropzone-content__buttonIcon", D = "forma-ui__file-dropzone-content__link", K = "forma-ui__file-dropzone-content__buttons", o = {
  acceptIcon: C,
  acceptFormat: P,
  title: w,
  placeholder: T,
  content: y,
  button: x,
  buttonIcon: B,
  link: D,
  buttons: K
}, r = ({ children: n, className: e }) => /* @__PURE__ */ t("div", { className: z(o.content, e), children: n }), _ = ({ accept: n, maxSize: e }) => {
  const { t: a } = I(), s = n && Object.values(n).flat().join(" " + a("uikit:or") + " ");
  return /* @__PURE__ */ l("div", { className: o.acceptFormat, children: [
    s && s + " ",
    a("uikit:up_to_mb", { value: Math.ceil(e / 1024 / 1024) })
  ] });
}, H = ({
  isPhone: n,
  isHovered: e,
  isDragAccept: a,
  isDragReject: s,
  title: d,
  placeholder: N,
  maxSize: u,
  maxFiles: k,
  accept: m,
  onClickAdd: p,
  className: c
}) => {
  const { t: f } = I();
  return n ? /* @__PURE__ */ t(r, { className: c, children: /* @__PURE__ */ t("div", { className: o.buttons, children: /* @__PURE__ */ t(
    h,
    {
      className: o.button,
      size: "small",
      onClick: (i) => {
        i.stopPropagation(), p();
      },
      icon: /* @__PURE__ */ t(b, {}),
      iconClassName: o.buttonIcon,
      fullWidth: !0,
      reversed: !0,
      children: f("uikit:upload")
    }
  ) }) }) : s ? /* @__PURE__ */ l(r, { className: c, children: [
    /* @__PURE__ */ t(j, { className: o.acceptIcon, width: 54, height: 66 }),
    /* @__PURE__ */ t(_, { accept: m, maxSize: u })
  ] }) : a ? /* @__PURE__ */ l(r, { className: c, children: [
    /* @__PURE__ */ t(F, { className: o.acceptIcon, width: 54, height: 66 }),
    /* @__PURE__ */ t(_, { accept: m, maxSize: u })
  ] }) : e ? /* @__PURE__ */ l(r, { className: c, children: [
    /* @__PURE__ */ t(g, { className: o.acceptIcon, width: 54, height: 66 }),
    /* @__PURE__ */ t(_, { accept: m, maxSize: u }),
    /* @__PURE__ */ t("div", { className: o.buttons, children: /* @__PURE__ */ t(
      h,
      {
        className: o.button,
        size: "small",
        onClick: (i) => {
          i.stopPropagation(), p();
        },
        icon: /* @__PURE__ */ t(b, {}),
        iconClassName: o.buttonIcon,
        reversed: !0,
        children: f("uikit:upload")
      }
    ) })
  ] }) : /* @__PURE__ */ l(r, { className: c, children: [
    d && /* @__PURE__ */ t("div", { className: o.title, children: d }),
    /* @__PURE__ */ t("div", { className: o.placeholder, children: N ?? /* @__PURE__ */ t(
      v,
      {
        i18nKey: "uikit:drag_file_or_select",
        components: {
          select: /* @__PURE__ */ t("span", { className: o.link, onClick: (i) => {
            i.stopPropagation(), p();
          } })
        },
        count: k
      }
    ) })
  ] });
};
export {
  H as default
};
